import i18n from '@core/plugins/i18n';
import { PermissionController } from '@core/permissions';
import { PointOfSale } from './models';

export const getters = {
  profileCompletion: (state, currentGetters, rootState, rootGetters) => state.profileCompletionList.find((completion) => completion.pointOfSale === rootGetters.selectedPointOfSale.guid),
  profileCompletionList: (state) => state.profileCompletionList,
  profilePercentage: (state) => Math.ceil(state.profileCompletionList.reduce((total, curr) => total + curr.percentage, 0) / state.profileCompletionList.length),
  allowedRadarKpis: (state, { getOptionByName }) => getOptionByName('front_kpis')?.allowed_radar_kpis || [],
  allowedEvolutiveKpis: (state, { getOptionByName }) => getOptionByName('front_kpis')?.allowed_evolutive_kpis || [],
  isLoading: ({ loading }) => loading > 0,
  pointOfSaleList: ({ pointOfSaleList }) => pointOfSaleList,
  selectedPointOfSale: ({ pointOfSaleList, selectedPointOfSaleGuid }) => pointOfSaleList.find((pos) => pos.guid === selectedPointOfSaleGuid) || PointOfSale.toInstance({ name: i18n.t('restaurants') }),
  currency: (state, { selectedPointOfSale }) => (selectedPointOfSale ? selectedPointOfSale.currency : ''),
  options: (state) => state.options,
  groupList: (state) => state.groupList,
  getOptionByName: (state) => (name) => state.options.find((el) => el.name === name)?.value,
  moduleStatus: (state) => state.moduleStatus,
  pointOfSaleLanguages: (state, getter) => {
    const alternatives = ['Alt1', 'Alt2', 'Alt3'];
    const result = [];
    alternatives.forEach((each) => {
      if (getter.selectedPointOfSale[`language${each}`]) {
        result.push({ ...getter.selectedPointOfSale[`language${each}`], alternative: each.toLowerCase() });
      }
    });
    return result;
  },
  moduleFunctionalities: (state, getter) => PermissionController.getInstance().getFunctionalities(),
  modelLanguageList: (state) => state.modelLanguageList,
};
